<app-tools-catalogue-menu
  [breadcrumbLinks]="breadcrumbLinks"
></app-tools-catalogue-menu>
<div class="container">
  <div class="columns">
    <div class="column is-10 is-offset-1 mt-6 pt-6">
      <div class="card has-background-white-ter my-6 has-text-centered shadow">
        <div class="columns">
          <div class="column is-10 is-offset-1 my-6">
            <i
              class="icon icon-check21 is-size-1 has-text-jungle-green my-6 pb-4"
            ></i>
            <h2>Thank you!</h2>
            <p *ngIf="resource === ResourceSlug.Tools">
              The tool has been successfully submitted. It is now awaiting
              validation by the OECD Secretariat.
            </p>
            <p *ngIf="resource === ResourceSlug.ToolUseCases">
              The use case has been successfully submitted. It is now awaiting
              validation by the OECD Secretariat.
            </p>
            <p *ngIf="resource === ResourceSlug.Metrics">
              The metric has been successfully submitted. It is now awaiting
              validation by the OECD Secretariat.
            </p>
            <p *ngIf="resource === ResourceSlug.MetricUseCases">
              The use case for a metric has been successfully submitted. It is
              now awaiting validation by the OECD Secretariat.
            </p>

            <div class="buttons is-flex is-justify-content-center">
              <a
                class="button is-link"
                routerLink="/catalogue/tools/submit"
                *ngIf="resource === ResourceSlug.Tools"
                >Submit another AI tool</a
              >
              <a
                class="button is-link"
                routerLink="/catalogue/tool-use-cases/submit"
                *ngIf="resource === ResourceSlug.ToolUseCases"
                >Submit another use case</a
              >
              <a
                class="button is-link"
                routerLink="/catalogue/metrics/submit"
                *ngIf="resource === ResourceSlug.Metrics"
                >Submit another metric</a
              >
              <a
                class="button is-link is-outlined"
                routerLink="/catalogue/tools"
                *ngIf="resource === ResourceSlug.Tools"
                >See all AI tools</a
              >
              <a
                class="button is-link is-outlined"
                routerLink="/catalogue/tool-use-cases"
                *ngIf="resource === ResourceSlug.ToolUseCases"
                >See all use cases</a
              >
              <a
                class="button is-link is-outlined"
                routerLink="/catalogue/metrics"
                *ngIf="resource === ResourceSlug.Metrics"
                >See all metrics</a
              >
              <a
                class="button is-link is-outlined"
                routerLink="/catalogue/metric-use-cases"
                *ngIf="resource === ResourceSlug.MetricUseCases"
                >See all metric use cases</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-tools-catalogue-disclaimer></app-tools-catalogue-disclaimer>
